import React, { Fragment } from 'react';
import { Stack, Box, Grid, Typography, Popover, IconButton } from '@mui/material';
import { StyledCard, StyledCardTitle, CustomInputLabel, CustomTextField, InputProps, FlexDiv, PopoverContent, PopoverHead, CloseIconProps } from '../../../../../../../custom/components';
import { EditIcon, DeleteIcon, DateFormat, AddIcon } from '../../../../../../../custom/constants';
import styles from '../../../../../../../custom/style.module.css';
import importStyles from './emailtemp.module.css';
import { ArrowDownward, ArrowUpward, Close as CloseIcon } from '@mui/icons-material';
import moment from 'moment';
import cookies from 'utils/cookies';
import BounceModal from './BounceModal';
import MailConfigModal from './MailConfigModal';
import TableWrapper from 'components/pages/common/TanStackTableWrapper';
import { CustomButton } from 'custom/components';

const EmailTemplate = (props) => {
  const { mails, swap, onRowMailClick, handleDeleteMail, footer, cc, ccErrors, onChangeCC, saveMailCC, bcc, bccErrors, onChangeBCC, saveMailBCC, saveMailFooter, onChangeFooter, footerError } = props;

  const SUB_TITLE_FS = '0.7rem';
  const SUB_TITLE_LH = 1;
  const SUB_TITLE_COLOR = '#000000c4';

  const bounceEmails = (props.bounceList || '')
    .split(',')
    .map((email) => email.trim())
    .filter(Boolean);

  const ccEmails = (props.ccList || '')
    .split(',')
    .map((email) => email.trim())
    .filter(Boolean);

  const bccEmails = (props.bccList || '')
    .split(',')
    .map((email) => email.trim())
    .filter(Boolean);

  const EMAIL_FIELDS = {
    cc: {
      label: 'CC',
      id: 'cc',
      value: cc,
      onChange: onChangeCC,
      onSave: saveMailCC,
      error: ccErrors?.cc,
      emails: ccEmails,
      onDeleteEmail: props.onDeleteCCEmail,
    },
    bcc: {
      label: 'BCC',
      id: 'bcc',
      value: bcc,
      onChange: onChangeBCC,
      onSave: saveMailBCC,
      error: bccErrors?.bcc,
      emails: bccEmails,
      onDeleteEmail: props.onDeleteBCCEmail,
    },
    bounce: {
      label: 'Notify Bounce',
      required: true,
      id: 'bounce',
      value: props.bounce,
      onChange: props.onChangeBounce,
      onSave: props.saveMailBounce,
      error: props.bounceErrors?.bounce,
      emails: bounceEmails,
      onDeleteEmail: props.onDeleteBounceEmail,
    },
  };

  const activeEmailConfig = props.activeEmailField ? EMAIL_FIELDS[props.activeEmailField] : null;

  const PREVIEW_TYPOGRAPHY = {
    fontSize: '0.8rem',
    color: '#000000c4',
    fontWeight: 400,
    marginBottom: '0.5rem',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  };

  const LABELPROPS = {
    minWidth: 200,
    fontSize: 'inherit',
    color: 'inherit',
  };

  const DATAPROPS = {
    fontSize: 'inherit',
    color: 'inherit',
  };

  const mailColumns = [
    {
      accessorKey: 'type',
      header: 'Type',
      cell: (info) => info.getValue(),
    },
    {
      accessorKey: 'name',
      header: 'Name',
      cell: (info) => info.getValue(),
    },
    {
      accessorKey: 'value',
      header: 'Position',
      enableSorting: false,
      meta: { align: 'center' },
      cell: ({ row }) => {
        const mailIndex = row.index;
        return (
          <Stack direction='row' spacing={2} justifyContent='space-between' width='100%'>
            {mailIndex > 0 && <ArrowUpward color='primary' className={importStyles.arrowIcon} onClick={() => { swap('up', mailIndex); }} />}
            {mailIndex < (mails?.length - 1) && <ArrowDownward color='primary' className={`${importStyles.arrowIcon} ${styles.mlauto}`} onClick={() => { swap('down', mailIndex); }} />}
          </Stack>
        );
      },
    },
    {
      accessorKey: 'action',
      header: 'Action',
      enableSorting: false,
      meta: { align: 'right' },
      cell: ({ row }) => {
        return (
          <Stack direction='row' spacing={2} justifyContent='flex-end' width='100%' className={styles.actionIcons}>
            {(row.original.type == 'Text' || row.original.type == 'Text SPL') && 
            <EditIcon onClick={() => {
              onRowMailClick(row.original);
              props.handleOpen('mailConfig');
            }} />}
            <DeleteIcon type='button' onClick={(e) => { handleDeleteMail(row.index, e.target); }} />
          </Stack>
        );
      }
    },
  ];

  const getEmailColumns = (onDeleteEmail) => [
    {
      accessorKey: 'email',
      header: 'Email',
      cell: (info) => info.getValue(),
    },
    {
      accessorKey: 'action',
      header: 'Action',
      enableSorting: false,
      meta: { align: 'right' },
      cell: ({ row }) => (
        <div className={styles.actionIcons}>
          <DeleteIcon type='button' onClick={() => onDeleteEmail(row.original.email)} />
        </div>
      ),
    },
  ];

  return (
    <div>
      <Grid container spacing={3} sx={{ justifyContent: 'center', }}>
        <Grid item container xs={12} md={10} lg={6} xl={4} spacing={2}>
          <Grid item xs={12} display='flex' flexDirection='column'>
            <Stack spacing={3} className={styles.h100}>
              {Object.entries(EMAIL_FIELDS).map(([field, config]) => (
                <StyledCard key={field} className={importStyles.emailFieldCard}>
                  <FlexDiv>
                    <Stack direction='row' sx={{
                      justifyContent: 'space-between',
                      alignItems:'center',
                      width: '100%',
                      mb: 0.5
                    }} >
                      <StyledCardTitle htmlFor={config.id} required={config.required} className={importStyles.emailFieldLabel}>{config.label}</StyledCardTitle>
                      <AddIcon title={`Add ${config.label} Email`} className={importStyles.addEmailBtn} onClick={props.openEmailPopover(field)} />
                    </Stack>
                  </FlexDiv>
                  {(field === 'cc' || field === 'bcc' || field === 'bounce') && (
                    <Box className={`${styles.tableOuter} ${importStyles.emailTableContainer}`}>
                      <TableWrapper
                        columns={getEmailColumns(config.onDeleteEmail)}
                        data={config.emails.map((email) => ({ email }))}
                      />
                    </Box>
                  )}
                </StyledCard>
              ))}
            </Stack>
          </Grid>
        </Grid>
        <Grid item xs={12} md={10} lg={6} xl={4} sx={{
          height: {
            xs: 'auto',
            xl: '100%' 
          },
          minHeight: 0,
        }}>
          <Stack spacing={3} sx={{
            height: {
              xs: 'auto',
              xl: '100%' 
            },
            minHeight: 0,
          }}>
            <StyledCard className={importStyles.emailPreviewCard} sx={{
              flex: {
                xs: 'none',
                xl: '3 1 0%' 
              },
              minHeight: 0,
            }}>
              <Stack direction='row' alignItems={'flex-start'} justifyContent='space-between'>
                <div>
                  <StyledCardTitle>Mail Template Configuration</StyledCardTitle>
                  <Typography component='span' fontSize={SUB_TITLE_FS} lineHeight={SUB_TITLE_LH} color={SUB_TITLE_COLOR} pt={0.5}>
              Content below will be used in the email template</Typography>
                </div>
                <CustomButton variant='outlined' color='primary' size='small'
                  onClick={props.onPreviewClick}
                  sx={{
                    display: {
                      xs: 'inline-flex',
                      xl: 'none'
                    }
                  }}
                  className={importStyles.previewButton}>
                Preview Mail Template</CustomButton>
                <AddIcon className={`${styles.mbauto} ${importStyles.addEmailBtn}`} title='Add Email'
                  onClick={() => props.handleOpen('mailConfig')} />
              </Stack>
            
              <Box className={`${styles.tableOuter} ${importStyles.mailTableOuter}`} mt={2} sx={{
                flex: 1,
                minHeight: 0,
              }}>
                <TableWrapper columns={mailColumns} data={mails} />
              </Box>
            </StyledCard>
            <StyledCard sx={{
              flex: {
                xs: 'none',
                xl: '1 1 0%' 
              },
              minHeight: 0,
            }}>
              <FlexDiv>
                <Stack direction='row' width={'100%'} justifyContent='space-between' alignItems='center'>
                  <div>
                    <StyledCardTitle>Mail Footer Configuration</StyledCardTitle>
                  </div>
                </Stack>
              </FlexDiv>
              <div>
                <form onSubmit={saveMailFooter}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <CustomInputLabel htmlFor='footer'>Footer</CustomInputLabel>
                      <CustomTextField
                        {...InputProps}
                        fullWidth
                        id='footer'
                        name='footer'
                        type=''
                        value={footer}
                        onChange={onChangeFooter}
                        error={footerError}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <CustomButton type='submit' variant='contained' fullWidth>Save</CustomButton>
                    </Grid>
                  </Grid>
                </form>
              </div>
            </StyledCard>
          </Stack>
        </Grid>
        <Grid item xs={12} md={10} lg={12} xl={4} id='mail-preview-section'>
          <StyledCard className={`${styles.h100} ${importStyles.emailPreviewCard}`} >
            <FlexDiv><StyledCardTitle>Mail Preview</StyledCardTitle></FlexDiv>
            <Typography component='span' fontSize={SUB_TITLE_FS} lineHeight={SUB_TITLE_LH} color={SUB_TITLE_COLOR} pt={0.5} mb={3}>
              The email content will match the preview shown.</Typography>
            <Stack className={importStyles.emailPreview} flex={'auto'} height={'100%'}>
              <Typography component='span' {...PREVIEW_TYPOGRAPHY}>
                Dear Customer,</Typography>
              <Typography component='span' {...PREVIEW_TYPOGRAPHY}>A shipment consigned to you has arrived at {cookies.get('station_code')} - {cookies.get('company_name')}.</Typography>
              <Stack mt={1.5}>

                {mails?.map((mail, index) => (
                  <Fragment key={index}>
                    <Typography component='div' {...PREVIEW_TYPOGRAPHY}>
                      <Typography {...LABELPROPS}>{mail.type.toLowerCase() === 'text' || mail.type.toLowerCase() === 'hyperlink' ? mail.name : mail.type} </Typography>
                      <Typography component='span' {...DATAPROPS}> : &nbsp;</Typography>
                      {mail.type.toLowerCase() === 'text' ? (
                        <Typography 
                          component='span' 
                          {...DATAPROPS}
                          dangerouslySetInnerHTML={{ __html: mail.value }}
                          sx={{
                            '& a': {
                              color: '#1976d2',
                              textDecoration: 'underline' 
                            },
                            '& p': {
                              display: 'inline',
                              margin: 0
                            }
                          }}
                        />
                      ) : mail.type.toLowerCase() === 'hyperlink' ? (
                        <Typography component='span' {...DATAPROPS}>
                          <a href={mail.value} target='_blank' rel='noopener noreferrer' style={{
                            color: '#1976d2',
                            textDecoration: 'underline' 
                          }}>{mail.display_text || mail.value}</a>
                        </Typography>
                      ) : (
                        <Typography component='span' {...DATAPROPS}>
                          {mail.type.toLowerCase() === 'pieces'
                            ? '14 pcs'
                            : mail.type.toLowerCase() === 'weight'
                              ? '1105.0K'
                              : mail.type.toLowerCase() === 'o-d'
                                ? 'MIA-HKG'
                                : mail.type.toLowerCase() === 'commodity'
                                  ? 'SHIP SPARE'
                                  : mail.type.toLowerCase() === 'flight number'
                                    ? 'EK213'
                                    : mail.type.toLowerCase() === 'arrival date'
                                      ? moment().format(DateFormat).toUpperCase()
                                      : mail.type.toLowerCase() === 'storage starts'
                                        ? moment().format(DateFormat).toUpperCase()
                                        : 'N/A'}
                        </Typography>
                      )}
                    </Typography>
                  </Fragment>
                ))}

              </Stack>
              <Stack mt={1.5}>
                <Typography component='p' {...PREVIEW_TYPOGRAPHY}>
                  Charges Due
                </Typography>
                <Typography component='p' lineHeight={0.2} {...PREVIEW_TYPOGRAPHY}>
                  ——————————
                </Typography>
                <Typography component='div' {...PREVIEW_TYPOGRAPHY}>
                  <Typography {...LABELPROPS}>Import Fee: </Typography>
                  <Typography {...DATAPROPS}> : &nbsp;$ 175 </Typography>
                </Typography>
                <Typography component='div' {...PREVIEW_TYPOGRAPHY}>
                  <Typography {...LABELPROPS}>Storage Fee: </Typography>
                  <Typography {...DATAPROPS}> : &nbsp;$ 36550 </Typography>
                </Typography>
              </Stack>
              <Typography component='div' {...PREVIEW_TYPOGRAPHY} mt={2}>
                {footer}
              </Typography>
            </Stack>
          </StyledCard>
        </Grid>
      </Grid>

      {Boolean(props.emailAnchorEl) && (
        <Popover
          open={Boolean(props.emailAnchorEl)}
          anchorEl={props.emailAnchorEl}
          onClose={props.closeEmailPopover}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          slotProps={{ paper: { className: importStyles.emailPopover, } }}
        >
          {activeEmailConfig && (
            <>
              <PopoverHead>
                <Typography fontWeight={600}>Add {activeEmailConfig.label} Email</Typography>
                <IconButton
                  aria-label='close'
                  onClick={props.closeEmailPopover}
                  size='small'
                  sx={{ ...CloseIconProps }}
                >
                  <CloseIcon fontSize='small' />
                </IconButton>
              </PopoverHead>
              <PopoverContent className={importStyles.popoverBody}>
                <form onSubmit={activeEmailConfig.onSave}>
                  <Stack direction='column' spacing={2}>
                    <Typography variant='caption' color={SUB_TITLE_COLOR}>
                    Add one or more email addresses (separate multiple email addresses with commas).
                    </Typography>
                    <CustomTextField
                      {...InputProps}
                      variant='outlined'
                      id='remark'
                      placeholder='Add email address(es)'
                      multiline
                      rows={3}
                      maxRows={Infinity}
                      name='remark'
                      fullWidth
                      inputProps={{ 'aria-label': 'remarks' }}
                      value={activeEmailConfig.value}
                      onChange={activeEmailConfig.onChange}
                      error={Boolean(activeEmailConfig.error)}
                      helperText={activeEmailConfig.error}
                      className={`${styles.borderedIpTextfield} ${styles.remarkIpTextarea}`}
                      InputProps={{
                        classes: {
                          root: `${styles.borderedIpRoot} ${styles.remarkIpRoot}`,
                          input: `${styles.borderedIp} ${styles.remarkIp}`,
                          notchedOutline: styles.notchedOutline,
                          error: styles.errorInput,
                        },
                      }}
                    />
                    <CustomButton variant='contained' type='submit' fullWidth disabled={!activeEmailConfig.value}>
                    Save
                    </CustomButton>
                  </Stack>
                </form>
              </PopoverContent>
            </>
          )}
        </Popover>
      )} 

      {props.modal === 'bounce' &&
        <BounceModal
          modal={props.modal}
          bounce={props.bounce}
          bounceErrors={props.bounceErrors}
          onChangeBounce={props.onChangeBounce}
          saveMailBounce={props.saveMailBounce}
          bounceList={props.bounceList}
          onDeleteBounceEmail={props.onDeleteBounceEmail}
          onClose={props.handleClose}
        />
      }

      {props.modal === 'mailConfig' &&
        <MailConfigModal
          modal={props.modal}
          mailFields={props.mailFields}
          mailFieldsErrors={props.mailFieldsErrors}
          editMail={props.editMail}
          onChangeMail={props.onChangeMail}
          footer={props.footer}
          footerError={props.footerErrors}
          onChangeFooter={props.onChangeFooter}
          saveMailFooter={props.saveMailFooter}
          handleClose={props.handleClose}
          saveMailConfig={props.saveMailConfig}
          type={props.type}
          mails={props.mails}
        />
      }
    </div>
  );
};

export default EmailTemplate;